export default __webpack_public_path__ + "static/media/shopping-cart-back.27980a6f.png";